import { useEffect, useRef } from "react";
import {
  FILTER_SELECTION_ALL,
  getFilterSelectionValidityAction,
} from "../utils/filterSelectionValidity";

/**
 * Clears a filter dropdown selection when it is no longer valid for the current option list.
 * Does not clear while options are still loading, and preserves URL drill-in ids.
 *
 * @param {object} args
 * @param {string} args.selectedId
 * @param {(next: string) => void} args.setSelectedId
 * @param {Array<{_id?: *}>} args.optionList
 * @param {boolean} args.optionsReady
 * @param {string} [args.preserveSelectedId]
 * @param {string} [args.allValue]
 * @param {() => void} [args.onClear] - extra cleanup (e.g. clear row selection)
 */
export function useClearInvalidFilterSelection({
  selectedId,
  setSelectedId,
  optionList,
  optionsReady,
  preserveSelectedId,
  allValue = FILTER_SELECTION_ALL,
  onClear,
}) {
  const onClearRef = useRef(onClear);
  onClearRef.current = onClear;

  useEffect(() => {
    const action = getFilterSelectionValidityAction({
      selectedId,
      optionList,
      optionsReady,
      preserveSelectedId,
      allValue,
    });
    if (action !== "clear") return;
    setSelectedId(allValue);
    if (typeof onClearRef.current === "function") onClearRef.current();
  }, [selectedId, setSelectedId, optionList, optionsReady, preserveSelectedId, allValue]);
}
